import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Z3HandoverBaseEffect } from './z3-handover-base.effect';

@NgModule({
  imports: [ EffectsModule.forFeature([ Z3HandoverBaseEffect ]) ]
})
export class Z3HandoverBaseModule {}
